module.exports = __webpack_public_path__ + "static/img/3.c2a5fc0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/zh/3.png
// module id = sHrG
// module chunks = 0